import { useCallback, useEffect, useState } from "react";
import { Loader2, FileCheck2 } from "lucide-react";
import { api } from "../lib/api";
import { PendingDocRow } from "./PendingDocsCard";

export const DocRequestsList = ({ onCount }) => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.docRequests().then((r) => { setItems(r); onCount && onCount(r.length); }).catch(() => setItems([])), [onCount]);
  useEffect(() => { load(); }, [load]);
  if (!items) return <div className="py-16 grid place-items-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (!items.length) return (
    <div className="py-16 text-center text-slate-400" data-testid="doc-requests-empty">
      <FileCheck2 className="mx-auto mb-2 h-10 w-10 opacity-40" /> لا توجد وثائق بانتظار الموافقة
    </div>
  );
  return (
    <div className="space-y-2" data-testid="doc-requests-list">
      {items.map((r) => <PendingDocRow key={r.id} req={r} empId={r.employee_id} showEmployee onDone={load} />)}
    </div>
  );
};
